// EC-614 - Implement a 'back to top' widget.

import { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Hidden from "@insite/mobius/Hidden";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

export interface GuestSuccessPageStyles {
    footerWrapper?: InjectableCss;
    backToTopButton?: ButtonPresentationProps;
}

export const guestSuccessPageStyles: GuestSuccessPageStyles = {
    footerWrapper: {
        css: css`
            display: flex;
            justify-content: center;
        `,
    },

    backToTopButton: {
        variant: "secondary",
        css: css`
            margin: 16px 0;
        `,
    },
};

const styles = guestSuccessPageStyles;

const StyledSection = getStyledWrapper("section");

const enum fields {
    target = "target",
    showOnlyInMobile = "showOnlyInMobile",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.target]: string;
        [fields.showOnlyInMobile]: boolean;
    };
}

type Props = OwnProps;

const BackToTop = ({ fields }: Props) => {
    const backToTopClickHandler = () => {
        const header = document.getElementById(fields.target);
        if (header) {
            window.scrollTo(0, header.offsetTop);
        }
    };
    if (fields.showOnlyInMobile) {
        return (
            <Hidden above="md">
                <StyledSection {...styles.footerWrapper}>
                    <Button onClick={backToTopClickHandler} {...styles.backToTopButton}>
                        {translate("Back to Top")}
                    </Button>
                </StyledSection>
            </Hidden>
        );
    }

    return (
        <StyledSection {...styles.footerWrapper}>
            <Button onClick={backToTopClickHandler} {...styles.backToTopButton}>
                {translate("Back to Top")}
            </Button>
        </StyledSection>
    );
};

const widgetModule: WidgetModule = {
    component: BackToTop,
    definition: {
        displayName: "Back To Top",
        group: "Common",
        fieldDefinitions: [
            {
                name: "target",
                displayName: "Scroll ID",
                editorTemplate: "TextField",
                defaultValue: "BackToTop",
                fieldType: "General",
            },
            {
                name: fields.showOnlyInMobile,
                displayName: "Only In Mobile",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                sortOrder: 2,
            },
        ],
    },
};

export default widgetModule;
